/**
 * Which of the three builds this is. `REACT_APP_MODE` is a build-time literal (vite `define`), so
 * every branch on the flags below is dead-code eliminated. Only this file and the entry
 * `index.jsx` read it: there the literal has to remove the other apps' `import()` before the
 * module graph is built, or rolldown still emits their chunks.
 *
 * - `app`: the member workspace at `<org>.codecks.io`
 * - `open`: Open Decks at `open.codecks.io`, public projects browsed by visitors
 * - `steamy`: the Steam-review Discord bot's settings page
 */
export type AppMode = "app" | "open" | "steamy";

const raw = process.env.REACT_APP_MODE;
export const appMode: AppMode = raw === "open" || raw === "steamy" ? raw : "app";

export const isOpenDecks = appMode === "open";
export const isSteamy = appMode === "steamy";

/**
 * Content is being looked at in a public context, where an admin, a member and a logged-out
 * visitor all see the same thing: no member-only fields (milestones, sprints, time tracking,
 * notifications, feature flags, plan), no editing, and only `isPublic` rows, with queries on cards,
 * threads and child cards saying so explicitly. Open Decks holds the `public` scope tier only, and
 * in dev a read outside it throws inside the collector.
 */
export const isPublicContext = isOpenDecks;
